/** Prep simulator + interview-journey endpoints. */
import client from './client';

export const prepAPI = {
  start: async (payload) => (await client.post('/prep/start', payload)).data,
  list: async () => (await client.get('/prep/sessions')).data,
  get: async (id) => (await client.get(`/prep/${id}`)).data,
  submitAnswer: async (id, questionIndex, answerText) =>
    (await client.post(`/prep/${id}/answer`, { question_index: questionIndex, answer_text: answerText })).data,
  complete: async (id) => (await client.post(`/prep/${id}/complete`)).data,
  remove: async (id) => (await client.delete(`/prep/${id}`)).data,
  transcribe: async (blob, filename = 'voice.webm') => {
    const fd = new FormData();
    fd.append('audio', blob, filename);
    return (await client.post('/prep/transcribe', fd, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
};

export const journeyAPI = {
  get: async (matchId) => (await client.get(`/journey/match/${matchId}`)).data,
  listMine: async () => (await client.get('/journey/applicant/my-applications')).data,
  advance: async (matchId, comment = '') => (await client.post(`/journey/match/${matchId}/advance`, { comment })).data,
  decide: async (matchId, decision, comment = '', rejection_reason = '') =>
    (await client.post(`/journey/match/${matchId}/decision`, { decision, comment, rejection_reason })).data,
  comment: async (matchId, comment) => (await client.post(`/journey/match/${matchId}/comment`, { comment })).data,
  setStage: async (matchId, { stage, decision = null, comment, rejection_reason = '' }) =>
    (await client.post(`/journey/match/${matchId}/set-stage`, { stage, decision, comment, rejection_reason })).data,
  requestDocuments: async (matchId, documents, comment = '') =>
    (await client.post(`/journey/match/${matchId}/request-documents`, { documents, comment })).data,
  uploadOffer: async (matchId, file, comment = '') => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('comment', comment || '');
    return (await client.post(`/journey/match/${matchId}/offer-letter`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
  uploadDocument: async (matchId, file, documentName) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('document_name', documentName);
    return (await client.post(`/journey/match/${matchId}/upload-document`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
  signOffer: async (matchId, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return (await client.post(`/journey/match/${matchId}/sign-offer`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
};

export const interviewJourneyAPI = {
  startJourneys: async (jobId, mode, matchIds = []) =>
    (await client.post(`/jobs/${jobId}/start-journeys`, { mode, match_ids: matchIds })).data,
};

export const interviewAPI = {
  create: async (jobId, candidateId) => (await client.post('/interviews/create', { job_id: jobId, candidate_id: candidateId })).data,
  get: async (id) => (await client.get(`/interviews/${id}`)).data,
  submitAnswer: async (id, questionIndex, questionText, answerText, audioUrl = '', duration = 0) =>
    (await client.post(`/interviews/${id}/answer`, { question_index: questionIndex, question_text: questionText, answer_text: answerText, audio_url: audioUrl, duration })).data,
  complete: async (id) => (await client.post(`/interviews/${id}/complete`)).data,
};

export default prepAPI;
